import { DetailPageActions, DetailPageActionTypes } from '../actions';
import { Reducer } from 'redux';

export type PageTitleId = string

export const initialState = ''

export const reducer: Reducer<PageTitleId, DetailPageActions> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case DetailPageActionTypes.STORE_MERGE:
            return action.payload && action.payload.pageTitleId || state
        case DetailPageActionTypes.RESET_STORE:
            return initialState
        default:
            return state
    }
}
